var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"help-third-page"},[_c('div',{class:_vm.lang === 'en' ? 'help-third-page-image-content-en' : 'help-third-page-image-content'}),_c('div',{staticClass:"help-third-page-text-content",attrs:{"data-langname":"lb_help_3"}})])}
var staticRenderFns = []

export { render, staticRenderFns }